<template>
  <RequestPermissions @checked="checked" />
</template>

<script>
import RequestPermissions from '@huntica/huntica-interview-module/src/components/RequestPermissions.vue';

export default {
  name: 'OfficeInterviewRequestMediaPermissions',
  components: {
    RequestPermissions,
  },
  methods: {
    checked() {
      this.$emit('done');
    },
  },
};
</script>
